import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketTimeTracking } from '../../../../state';
import { shouldCommitDateInputChange } from '../../../../../../utils/DateConversions';

// Stored/displayed as a plain YYYY-MM-DD string, matching Start/End Date; end-of-day is applied at submit time.
const DueDateEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value;
    if (!shouldCommitDateInputChange(raw, currentTicket?.timeTracking.dueDate)) return;
    dispatch(updateTicketTimeTracking({ dueDate: raw || undefined }));
  };

  return (
    <TextField
      label="Due Date"
      size="small"
      type="date"
      fullWidth
      value={currentTicket?.timeTracking.dueDate || ''}
      onChange={handleChange}
      InputLabelProps={{ shrink: true }}
    />
  );
};

export default DueDateEdit;
